import { useSwitch, type UseSwitchParameters } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type FC } from 'react'

import { StaticImage } from '../../../../../image'

import RedcareSvgIconCheck from './RedcareSvgIconCheck.svg'

import styles from './Checkbox.module.css'

type CheckboxProps = Omit<UseSwitchParameters, 'defaultChecked'> & {
  'aria-label'?: string
  className?: string
  id: string
  label: string
  name: string
  value?: string
}

export const RxLpChCheckbox: FC<CheckboxProps & ComponentProps<'input'>> = (
  props,
) => {
  const { className, id, label, name, ref, value, ...rest } = props
  const { checked, getInputProps, readOnly } = useSwitch(rest)
  const checkboxProps: { value?: string } = {}

  if (value) {
    checkboxProps.value = value
  }

  return (
    <label
      className="flex items-start gap-2.5 self-stretch text-m leading-m text-dark-primary-max"
      htmlFor={name}
    >
      <input
        {...getInputProps()}
        checked={checked}
        className={clsx(styles.checkbox, className)}
        id={id}
        name={name}
        readOnly={readOnly}
        ref={ref}
        type="checkbox"
        {...checkboxProps}
      />
      <div
        className={clsx(
          styles.checkbox__icon,
          'flex shrink-0 items-center rounded-s border bg-light-primary-low',
          checked && '!border-dark-brand',
        )}
        data-qa-id={label}
      >
        {checked ? <StaticImage alt="" src={RedcareSvgIconCheck} /> : null}
      </div>
      <span>{label}</span>
    </label>
  )
}
